import {
    ASSIGN_ACCESS,
    CHANGE_NOTIFICATIONS,
    CHANGE_PASSWORD_REQUEST,
    GET_ACCESS,
    GET_MY_PROFILE,
    GET_RECOVERY_LINK,
    GET_RECOVERY_LINK_TRY_AGAIN,
    LOG_IN,
    LOG_OUT,
    REMOVE_ACCESS,
    RESET_PASSWORD_REQUEST,
    SAVE_PROJECT_SESSION,
    SAVE_QR_SCANNING,
    UPDATE_SCHEDULE_VIEW,
} from './auth.types';

export const logIn = (user) => {
    return {
        type: LOG_IN,
        payload: { user },
    };
};

export const logOut = () => {
    return {
        type: LOG_OUT,
    };
};

export const getMyProfile = (load) => {
    return {
        type: GET_MY_PROFILE,
        payload: { load },
    };
};

export const getRecoveryLink = (email) => {
    return {
        type: GET_RECOVERY_LINK,
        payload: email,
    };
};

export const tryAgain = () => {
    return {
        type: GET_RECOVERY_LINK_TRY_AGAIN,
    };
};

export const resetPassword = (passwords, email) => {
    return {
        type: RESET_PASSWORD_REQUEST,
        payload: { passwords, email },
    };
};

export const changePassword = (data) => {
    return {
        type: CHANGE_PASSWORD_REQUEST,
        payload: { data },
    };
};

export const changeNotifications = (id, data) => {
    return {
        type: CHANGE_NOTIFICATIONS,
        payload: { id, data },
    };
};

/** Access service */
export const getAccess = (userId) => {
    return {
        type: GET_ACCESS,
        payload: { userId },
    };
};

export const assignAccess = (userId, roleId) => {
    return {
        type: ASSIGN_ACCESS,
        payload: { userId, roleId },
    };
};

export const removeAccess = (userId, roleId) => {
    return {
        type: REMOVE_ACCESS,
        payload: { userId, roleId },
    };
};
export const saveQrScanning = (body) => {
    return {
        type: SAVE_QR_SCANNING,
        payload: { body },
    };
};

/** End */

export const saveTherapySession = (body) => {
    return {
        type: SAVE_PROJECT_SESSION,
        payload: { body },
    };
};

export const updateScheduleView = (data) => {
    return {
        type: UPDATE_SCHEDULE_VIEW,
        payload: { data },
    };
};
